const Tk = (props) => (
  <svg viewBox='0 0 32 32' fill='none' {...props}>
    <path fillRule='evenodd' clipRule='evenodd'
      d='M15.9315 31.8688C24.6827 31.8688 31.777 24.7745 31.777 16.0233C31.777 7.27203 24.6827 0.177734 15.9315 0.177734C7.18023 0.177734 0.0859375 7.27203 0.0859375 16.0233C0.0859375 24.7745 7.18023 31.8688 15.9315 31.8688ZM16.5647 7.03552H19.5214C19.5214 9.33543 21.2651 11.2172 23.4889 11.2956V14.3796C22.0485 14.3534 20.6839 13.8569 19.5719 13.0205V19.3191C19.5719 22.4815 17.0954 25.0689 14.0377 25.0689C10.9799 25.0689 8.50339 22.5077 8.50339 19.3191C8.50339 16.1568 10.9294 13.6216 13.9366 13.5694V16.6533C12.572 16.7056 11.4601 17.8817 11.4601 19.3191C11.4601 20.7828 12.5972 21.985 14.0124 21.985C15.4276 21.985 16.5647 20.7828 16.5647 19.3191V7.03552Z'
      fill='#FFE42B' />
  </svg>
)

export default Tk



// WEBPACK FOOTER //
// ./components/icons/tk.js